import { defineMessages } from 'react-intl'

export default defineMessages({
  updated: {
    id: 'Updated',
    defaultMessage: 'updated'
  },
  allUsers: {
    id: 'AllUsers',
    defaultMessage: 'Default, all users'
  },
  NoSearchResult: {
    id: 'SortAndFilter.NoSearchResult',
    defaultMessage: 'There are no results for this search'
  }
})
